import { onMounted, onUnmounted, ref } from 'vue'

export function useAnimateOnScroll(elementRef, options = {}) {
  const {
    threshold = 0.1,
    animateClass = 'animate-in',
    once = true,
  } = options

  let observer = null
  const elements = ref([])

  const observe = (el) => {
    if (!el || !observer) return
    observer.observe(el)
    elements.value.push({ el, isVisible: false })
  }

  const observeElements = (selector) => {
    const els = document.querySelectorAll(selector)
    els.forEach(el => observe(el))
  }

  onMounted(() => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(animateClass)
            const found = elements.value.find(e => e.el === entry.target)
            if (found) found.isVisible = true

            if (once && observer) {
              observer.unobserve(entry.target)
            }
          }
        })
      },
      { threshold }
    )

    if (elementRef && elementRef.value) {
      observe(elementRef.value)
    }
  })

  onUnmounted(() => {
    if (observer) {
      observer.disconnect()
      observer = null
    }
  })

  return { observe, observeElements, elements }
}

export default useAnimateOnScroll
